import styled from 'styled-components';

export const AlertContainer = styled.div`
    display: flex;
    width: 250px;
    height: 200px;
    position: absolute;
    flex-direction: column;
    justify-content: center !important;
    align-items: center !important;

    top: 50%;
    right: 50%;
    transform: translate(50%, -50%);
    border-radius: 5px;
    
    z-index: 1;
    background: ${props => props.theme.asideColor};

    h1 {
        text-align: center;
        font-size: 22px;
        color: ${props => props.theme.secondaryColor};
    }

    div {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
    }

`